export default __webpack_public_path__ + "static/BGLogo-9ee22924d3b221bf959e411553dae2a6.png";